import { BrandTypes } from '@lib/domain/order';

export enum Level {
    low = 'low',
    medium = 'medium',
    high = 'high',
}
export interface Discount {
    title: string;
    price: Record<Level, number>;
    value: Record<Level, number>;
    branch_type: BrandTypes;
    min: number;
}

export const DISCOUNT: Record<string, Discount> = {
    tiktok: {
        title: 'One Time Offer 🔥',
        branch_type: BrandTypes.tiktok,
        value: {
            low: 1000,
            medium: 2000,
            high: 5000,
        },
        price: {
            low: 9.9,
            medium: 16.9,
            high: 34.9,
        },
        min: 10,
    },
    twitch: {
        title: 'One Time Offer 🔥',
        branch_type: BrandTypes.twitch,
        value: {
            low: 200,
            medium: 500,
            high: 1500,
        },
        price: {
            low: 6.9,
            medium: 14.9,
            high: 24.9,
        },
        min: 10,
    },
    youtube: {
        title: 'One Time Offer 🔥',
        branch_type: BrandTypes.youtube,
        value: {
            low: 100,
            medium: 200,
            high: 400,
        },
        price: {
            low: 8.9,
            medium: 14.9,
            high: 24.9,
        },
        min: 10,
    },
    instagram: {
        title: 'One Time Offer 🔥',
        branch_type: BrandTypes.instagram,
        value: {
            low: 250,
            medium: 500,
            high: 1500,
        },
        price: {
            low: 7.9,
            medium: 19.9,
            high: 31.9,
        },
        min: 15,
    },
    twitter: {
        title: '50% Discount 🔥',
        branch_type: BrandTypes.twitter,
        value: {
            low: 200,
            medium: 600,
            high: 2000,
        },
        price: {
            low: 7.9,
            medium: 14.9,
            high: 29.9,
        },
        min: 10,
    },
};
export const SUBSCRIPTION_NEXT_POSTS = 10
